<template>
  <v-card rounded="xxl" elevation="0" color="grey lighten-2" min-height="90vh" class="my-4">
    <v-row class="mx-2">
      <v-col cols="3">
        <div class="card">
          <ModuleHeader>Selecciona una fecha</ModuleHeader>
          <uvCalendar v-model="date" @onSelect="selectDate" :events="listeEvents" :eventsName="eventsName"
            @onChangeMonth="changeMonth">
          </uvCalendar>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="card">
          <ModuleHeader>Reservaciones del día</ModuleHeader>
          <v-text-field v-model="name_filter" label="Filter by Name or Reservation Number " />
          <v-tabs v-model="tab" show-arrows>
            <template v-for="(statu, indexStatus) in compStatus">
              <v-tab :key="indexStatus">{{
                statu.cantidad + " " + statu.Nombre
              }}</v-tab>
            </template>
            <template v-for="(statu, indexStatus) in compStatus">
              <v-tab-item :key="indexStatus">
                <template v-for="(reservation, index) in listReservation">
                  <item-list :key="index" v-if="statu.Nombre === reservation.Estatus"
                    @clickedItem="showDetailReservation" :reservation="reservation" :actualDate="actualDate">
                  </item-list>
                </template>
              </v-tab-item>
            </template>
          </v-tabs>
        </div>
      </v-col>
      <v-col cols="5">
        <div class="card">
          <ModuleHeader>Detalle</ModuleHeader>
          <detailCard :showDetail="showDetail" :selectedItem="selectedItem" :status="status" @openModal="toogleModal">
          </detailCard>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<style scoped>
.card {
  background-color: white;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
}
</style>

<script>
import detailCard from "../Reportes/detailReservationCard.vue";
import itemList from "../Reportes/reservationListItem.vue";
import uvCalendar from "../MainComponents/simple-vue-calendar";
import moment from "moment";

export default {
  name: "listReserva",
  components: {
    detailCard,
    itemList,
    uvCalendar,
    //vuCalendar
  },
  props: ["isHotel", "hideMenu"],
  data() {
    return {
      tab: 1,
      formKey: 0,
      showModal: false,
      date: moment().format("YYYY-MM-DD"),
      input_date: moment(),
      eventsName: "reservas",
      reservations: [],
      listeEvents: [],
      status: [],
      list_status: [],
      selectedItem: "",
      name_filter: "",
      showDetail: false,
      tabName: "Confirmed",
      actualDate: moment(),
      endMonthDate: moment().endOf("month").format("YYYY-MM-DD"),
      startMonthDate: moment().startOf("month").format("YYYY-MM-DD"),
    };
  },
  methods: {
    toogleModal(open) {
      this.showModal = open;
    },
    showDetailReservation(index) {
      this.showDetail = false;
      this.selectedItem = this.reservations[index];
      this.showDetail = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.showDetail = false;
      this.getReservas();
    },
    changeMonth(month, start, end) {
      this.$pgsHelper.log(month);
      this.endMonthDate = end;
      this.startMonthDate = start;
      this.getReservasMonth();
    },
    getSuccessData(data) {
      let dataEdit = {
        fecha: data.date.format("YYYY-MM-DD"),
        hora: moment(data.hora).format("HH:mm:ss"),
        idReserva: data.id,
      };

      this.$swal({
        title: "Deseas editar esta reserva?",
        text: "Se modificaran los datos de la reserva",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addTarifa = this.$store.getters.getFirebaseApp.fba.call('Golf-Tarifas-crearTarifa');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Reservas-editarReserva", dataEdit)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Reserva Modificada",
              "La reserva se edito correctamente",
              "success",
            );

            this.showModal = false;
            this.formKey++;
            this.showDetail = false;
            this.getReservas();
            this.getReservasMonth();
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    async getReservasMonth() {
      let startDate = this.startMonthDate;
      let end = this.endMonthDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1),
      );

      const data =
        await this.$store.getters.getFirebaseApp.firestore.queryBuilder(
          "RVA_Reservas",
          [
            this.$store.getters.getFirebaseApp.firestore.where(
              "RF.FI",
              ">=",
              startDate,
            ),
            this.$store.getters.getFirebaseApp.firestore.where(
              "RF.FI",
              "<",
              end,
            ),
            this.$store.getters.getFirebaseApp.firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant,
            ),
          ],
        );

      this.listeEvents = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.listeEvents.forEach((element) => {
        element.Date = moment(element.RF.FI, "YYYY-MM-DD_HH:mm:ss").format(
          "YYYY-MM-DD",
        );
      });
    },
    async getReservas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const end = startDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1),
      );
      const data =
        await this.$store.getters.getFirebaseApp.firestore.queryBuilder(
          "RVA_Reservas",
          [
            this.$store.getters.getFirebaseApp.firestore.where(
              "RF.FI",
              ">=",
              startDate,
            ),
            this.$store.getters.getFirebaseApp.firestore.where(
              "RF.FI",
              "<",
              end,
            ),
            this.$store.getters.getFirebaseApp.firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant,
            ),
          ],
        );
      let reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      reservations.forEach((element) => {
        if (element.Tags) {
          element.Tags.forEach((tag) => {
            if (tag == "TOPTRACER") {
              element.TypeRes = "TOPTRACER";
            } else if (tag == "GOLF") {
              element.TypeRes = "GOLF";
            }
          });
        }

        let cuentas = Object.entries(element.Cuentas);
        element.Cuentas = cuentas.map((doc) => {
          return { indexCuenta: doc[0], ...doc[1] };
        });
      });

      this.reservations = reservations;
    },
    async getStatus() {
      const database = this.$store.getters.getFirebaseApp.database;
      let data = await database.queryBuilder("Golf/Estatus", [
        database.orderByValue(),
        database.startAt(true),
        database.endAt(true),
      ]);
      let status = data.val();

      this.status = status;
    },
  },
  computed: {
    listReservation() {
      this.reservations.forEach((element) => {
        element.momentDate = moment(element.RF.FI, "YYYY-MM-DD_HH:mm:ss");
      });

      let sortReservations = this.$_.orderBy(
        this.reservations,
        "Fecha.RF.FI",
        "asc",
      );

      if (this.name_filter !== "") {
        let filter = this.$_.map(sortReservations, (o) => {
          if (
            o.Cliente.Nombre.toUpperCase().includes(
              this.name_filter.toUpperCase(),
            ) ||
            o.Folio.includes(this.name_filter.toUpperCase())
          )
            return o;
        });
        filter = this.$_.without(filter, undefined);
        return filter;
      }

      return sortReservations;
    },
    compStatus() {
      let arrayStatus = [];
      let status = [];
      if (this.status) {
        status = Object.keys(this.status);
      }
      //let status = Object.keys(this.status);
      status.forEach((element, index) => {
        let selected = false;
        let totalRes = 0;
        this.listReservation.forEach((res) => {
          if (res.Estatus === element) {
            totalRes++;
          }
        });
        arrayStatus.push({
          id: index,
          Nombre: element,
          cantidad: totalRes,
          selected: selected,
        });
      });

      return arrayStatus;
    },
  },
  beforeMount: function () {
    this.getStatus();
    this.getReservasMonth();
    this.$emit("useNav", true);
  },
  mounted() {
    this.getReservas();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>
